'use client';

import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { gql, useQuery } from '@parkchirp/api-client';
import { type AppNames } from 'parkchirp-shared/enums';
import React from 'react';

const GET_PROHIBIT_PREVIOUS_PARKING_PERIOD_PARKERS = gql`
	query getProhibitPreviousParkingPeriodParkers($facilityIds: [String!]!) {
		getProhibitPreviousParkingPeriodParkers(facilityIds: $facilityIds)
	}
`;

interface BackBillInvoicesModalProps {
	handleDismiss: () => void;
	handleConfirm: () => void;
	closeModal: () => void;
	facilityIds: string[];
	appName?: AppNames;
}

export const BackBillInvoicesModal = ({
	handleDismiss,
	handleConfirm,
	closeModal,
	facilityIds,
	appName,
}: BackBillInvoicesModalProps): JSX.Element => {
	const { data } = useQuery(GET_PROHIBIT_PREVIOUS_PARKING_PERIOD_PARKERS, {
		variables: { facilityIds },
		context: {
			apiVersion: 'v2',
			...(appName && { appName }),
		},
		fetchPolicy: 'network-only',
	});
	const prohibitPreviousParkingPeriodParkers = data?.getProhibitPreviousParkingPeriodParkers ?? true;

	if (prohibitPreviousParkingPeriodParkers) {
		return (
			<Box
				style={{
					display: 'flex',
					flexDirection: 'column',
				}}
			>
				<CancelOutlinedIcon
					onClick={closeModal}
					style={{
						alignSelf: 'flex-end',
						cursor: 'pointer',
						fontSize: '30px',
					}}
				/>
				<Box
					style={{
						padding: '25px 30px 5px',
						display: 'flex',
						alignSelf: 'center',
						textAlign: 'center',
					}}
				>
					<Typography
						style={{
							fontSize: '18px',
							lineHeight: '35px',
						}}
						variant='body1'
						data-cy='modal-body-text'
					>
						Some of the parkers being activated have a start date in a previous parking period.
						<br />
						Before you can activate them, you must change the dates.
					</Typography>
				</Box>
			</Box>
		);
	}

	return (
		<Box
			style={{
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			<CancelOutlinedIcon
				onClick={closeModal}
				style={{
					alignSelf: 'flex-end',
					cursor: 'pointer',
					fontSize: '30px',
				}}
			/>
			<Box
				style={{
					padding: '25px 30px 5px',
					display: 'flex',
					alignSelf: 'center',
					textAlign: 'center',
				}}
			>
				<Typography
					style={{
						fontSize: '18px',
						lineHeight: '35px',
					}}
					variant='body1'
					data-cy='modal-body-text'
				>
					Some of the parkers being activated have a start date in the past.
					<br />
					Do you want to create invoices for the parker&#39;s previous parking periods?
				</Typography>
			</Box>
			<Box
				sx={{
					textAlign: 'center',
					'& button': {
						margin: '25px',
					},
				}}
			>
				<Button variant='outlined' onClick={handleDismiss} data-cy='modal-cancel-button'>
					Activate Parkers Only
				</Button>
				<Button variant='outlined' onClick={handleConfirm} data-cy='modal-confirm-button'>
					Activate and Back Bill
				</Button>
			</Box>
		</Box>
	);
};
